/**
 * Box-average downscale of an RGBA grayscale ImageData by integer factor.
 * Output dimensions are floor(W/factor) x floor(H/factor).
 * Operates on the red channel only (assumes input is grayscale, R=G=B).
 */
export function downscaleBoxAverage(src: ImageData, factor: number): ImageData {
  if (factor <= 1) return src;
  const dstW = Math.floor(src.width / factor);
  const dstH = Math.floor(src.height / factor);
  const dst = new ImageData(dstW, dstH);
  const f2 = factor * factor;
  const srcData = src.data;
  const dstData = dst.data;
  const srcW = src.width;

  for (let y = 0; y < dstH; y++) {
    for (let x = 0; x < dstW; x++) {
      let sum = 0;
      for (let dy = 0; dy < factor; dy++) {
        for (let dx = 0; dx < factor; dx++) {
          const sx = x * factor + dx;
          const sy = y * factor + dy;
          sum += srcData[(sy * srcW + sx) * 4] ?? 0;
        }
      }
      const avg = Math.round(sum / f2);
      const di = (y * dstW + x) * 4;
      dstData[di] = avg;
      dstData[di + 1] = avg;
      dstData[di + 2] = avg;
      dstData[di + 3] = 255;
    }
  }

  return dst;
}
